import { useMemo } from 'react';
import { useQuery } from '@apollo/client/react';
import { DocumentType } from 'shared/domains/apollo/generated/types';
import { DocumentPreviewDataDocument } from './DocumentPreviewData.gql';
/**
 * Fetches the data needed to preview a document without leaving the screen: its name, its html body
 * and what kind of preview it supports.
 */
export function useDocumentPreviewData(id) {
    const { data, loading, error } = useQuery(DocumentPreviewDataDocument, {
        variables: { id: id },
        skip: !id,
    });
    const { document } = data || {};
    const renderType = useMemo(() => {
        // We should never render this because we are still loading if we have no document
        if (!document) {
            return 'html';
        }
        if (document.lastSignRequest || document.type === DocumentType.Uploaded) {
            return 'pdf';
        }
        return 'html';
    }, [document]);
    return {
        document,
        name: document === null || document === void 0 ? void 0 : document.name,
        html: document === null || document === void 0 ? void 0 : document.htmlBody,
        renderType,
        loading,
        error,
    };
}
